const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    "Missing required environment variables VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY. " +
      "The Help Centre cannot start without publishable database credentials."
  );
}

export const SUPABASE_URL = url;
export const SUPABASE_ANON_KEY = anonKey;
export const SITE_ORIGIN = "https://help.trustreq.ca";
